export class ParkingPass {
    static fromExistingData(booking: any): ParkingPass {
        const parkingPass = new ParkingPass();

        if (booking.building) parkingPass.buildingId = +booking.building.buildingId;
        if (booking.building) parkingPass.buildingName = booking.building.buildingName;
        if (booking.building) parkingPass.buildingTimezone = booking.building.timeZone;
        if (booking.id) parkingPass.id = booking.id;
        if (booking.otherResident) parkingPass.otherResident = booking.otherResident;
        if (booking.otherSuite) parkingPass.otherSuite = booking.otherSuite;
        if (booking.resident) parkingPass.residentId = +booking.resident.bdId;
        if (booking.resident) parkingPass.residentFullName = booking.resident.fullName;
        if (booking.resident) parkingPass.residentEmail = booking.resident.email;
        if (booking.resident) parkingPass.residentLicensePlate = booking.resident.licensePlate;
        if (booking.resident) parkingPass.residentVehicle = booking.resident.vehicle;
        if (booking.suite) parkingPass.suiteId = booking.suite.bdId;
        if (booking.suite) parkingPass.suiteNumber = booking.suite.suiteNumber;
        if (booking.createdBy) parkingPass.createdBy = booking.createdBy.fullName;
        if (booking.createdAt) parkingPass.createdAt = booking.createdAt;
        if (booking.status) parkingPass.status = booking.status;
        if (booking.passType) parkingPass.passTypeId = booking.passType.id;
        if (booking.passType) parkingPass.passTypeName = booking.passType.name;
        if (booking.dateFrom) parkingPass.dateFrom = booking.dateFrom;
        if (booking.dateTo) parkingPass.dateTo = booking.dateTo;
        if (booking.notes) parkingPass.notes = booking.notes;
        if (booking.payment) parkingPass.payment = booking.payment;
        if (booking.visitor) parkingPass.visitorId = +booking.visitor.bdId;
        if (booking.visitor) parkingPass.visitorFullName = booking.visitor.fullName;
        if (booking.visitor) parkingPass.visitorEmail = booking.visitor.email;
        if (booking.visitor) parkingPass.visitorLicensePlate = booking.visitor.licensePlate;
        if (booking.visitor) parkingPass.visitorVehicle = booking.visitor.vehicle;
        if (booking.parkingLot) parkingPass.parkingLot = booking.parkingLot;
        if (booking.parkingRule) parkingPass.parkingRule = booking.parkingRule;
        if (booking.bookingParkingLot) parkingPass.bookingParkingLot = booking.bookingParkingLot;
        if (booking.bookingPassTypes) parkingPass.bookingPassTypes = booking.bookingPassTypes;
        if (booking.bookingNumber) parkingPass.bookingNumber = booking.bookingNumber;
        if (booking.timeRelatedStatus) parkingPass.timeRelatedStatus = booking.timeRelatedStatus;
        if (this.managerApprovalRequiredPresent(booking)) parkingPass.approvalRequired = this.managerApprovalRequiredPresent(booking);
        parkingPass.isCanEdit = booking.isCanEdit;
        parkingPass.isCanDelete = booking.isCanDelete;
        parkingPass.isCanApprove = booking.isCanApprove;

        return parkingPass;
    }

    static managerApprovalRequiredPresent(parkingPass): boolean {
        let managerApprovalRequiredPresent = false;
        if(parkingPass.parkingRule) {
            parkingPass.parkingRule.passTypes.filter(type => {
                if (type.requiresManagerApproval)
                    managerApprovalRequiredPresent = true;
            });
        }
        return managerApprovalRequiredPresent;
    }

    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public buildingTimezone: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public residentLicensePlate: string = '',
        public residentEmail: string = '',
        public residentVehicle: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public passTypeId: number = null,
        public passTypeName: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public isCanApprove: boolean = true,
        public day: string = '',
        public endDay: string = '',
        public notes: any = null,
        public acknowledgement: boolean = false,
        public payments: any = null,
        public createdBy: string = '',
        public createdAt: string = '',
        public status: string = '',
        public timeRelatedStatus: string = '',
        public paymentMethod: string = '',
        public payment: any = null,
        public paid: boolean = false,
        public dateFrom: string = '',
        public dateTo: string = '',
        public visitorId: number = null,
        public visitorFullName: string = '',
        public visitorEmail: string = '',
        public visitorLicensePlate: string = '',
        public visitorVehicle: string = '',
        public parkingLot: any = null,
        public parkingRule: any = null,
        public bookingParkingLot: any = null,
        public managementOverride: boolean = false,
        public approvalRequired: boolean = false,
        public bookingPassTypes: any = null,
        public bookingNumber: string = ''
    ) {
    }

}



// WEBPACK FOOTER //
// /app/src/app/types/models/ParkingPass.ts